import React, {useEffect, useId, useLayoutEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

export default function AvailabilityOverlapTime({children, className, participants, heading}) {
  const id = useId();
  const trigger = useRef(null);
  const tooltip = useRef(null);
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState(null);
  useLayoutEffect(() => {
    if (!open || !trigger.current || !tooltip.current) return;
    const anchor = trigger.current.getBoundingClientRect();
    const box = tooltip.current.getBoundingClientRect();
    const below = anchor.bottom + 8;
    const top = below + box.height <= window.innerHeight - 8 ? below : anchor.top - box.height - 8;
    setPosition({left: Math.max(8, Math.min(anchor.left, window.innerWidth - box.width - 8)), top: Math.max(8, top)});
  }, [open, participants]);
  useEffect(() => {
    if (!open) return undefined;
    const close = () => setOpen(false);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [open]);
  const show = () => setOpen(true);
  return <>
    <span ref={trigger} className={className} tabIndex={0} aria-describedby={open ? id : undefined}
      onMouseEnter={show} onMouseLeave={() => setOpen(false)} onFocus={show} onBlur={() => setOpen(false)}
      onKeyDown={event => {if (event.key === 'Escape') setOpen(false);}}>{children}</span>
    {open && trigger.current && createPortal(
      <div ref={tooltip} id={id} role="tooltip" className="availability-overlap-tooltip"
        style={{...position, visibility: position ? 'visible' : 'hidden'}}>
        <strong>{heading}</strong>
        <span className="summary-names">
          {participants.map(member => <span key={member.uid} className={`role-name role-${member.role}`}>{member.name}</span>)}
        </span>
      </div>, trigger.current.closest('.availability-wrapper--embedded') ? document.body : trigger.current.closest('.availability-wrapper') || document.body)}
  </>;
}
